import i18next from 'i18next';
import type { ElawContract } from '@/types/approval';

/** 계약 카드 표기 규칙 — 작성·조회 공용. 값 없음은 전부 '-' */

const EMPTY = '-';

export const formatContractText = (value: string | null | undefined): string =>
  value && value.trim() ? value : EMPTY;

/** "30000000" → "30,000,000원". 숫자로 못 읽으면 원문 유지(법틀 원문이 "협의" 같은 문구일 수 있음) */
export const formatContractAmount = (
  amount: string | null | undefined,
): string => {
  if (!amount || !amount.trim()) return EMPTY;
  const numeric = Number(amount.replace(/,/g, ''));
  if (!Number.isFinite(numeric)) return amount;
  const formatted = numeric.toLocaleString('ko-KR');
  return i18next.t('{{amount}}원', { amount: formatted }) || `${formatted}원`;
};

/** 날짜 부분만 — "2026-01-01T00:00:00" → "2026-01-01", 법틀 "2026/07/29 00:00:00" → "2026/07/29"(레거시 표기). 날짜 형태가 아니면 원문 유지 */
export const formatContractDate = (
  value: string | null | undefined,
): string => {
  if (!value) return EMPTY;
  const match = value.match(/^\d{4}([-/])\d{2}\1\d{2}/);
  return match ? match[0] : value;
};

/** 시작일·만료일 한쪽만 있어도 "2026-01-01 ~ -" 로 자리 유지 */
export const formatContractPeriod = (
  startDate: string | null | undefined,
  expireDate: string | null | undefined,
): string =>
  !startDate && !expireDate
    ? EMPTY
    : `${formatContractDate(startDate)} ~ ${formatContractDate(expireDate)}`;

/**
 * 신규·갱신 표기. BE 목록 응답에 아직 필드가 없어 대부분 null → '-'.
 * 라벨은 호출부가 t() 로 넘김
 */
export const formatContractRenewal = (
  isNewContract: boolean | null | undefined,
  labels: { renewal: string; extension: string },
): string => {
  if (isNewContract === true) return labels.renewal;
  if (isNewContract === false) return labels.extension;
  return EMPTY;
};

/**
 * 법틀 열람 링크 → 새 탭용 href. 스킴이 없으면 https 를 붙임
 * (레거시가 `'https://' + access_link` 로 열던 호환, 스웨거는 스킴 명시 없음)
 */
export const toContractHref = (
  accessLink: string | null | undefined,
): string | null => {
  const link = accessLink?.trim();
  if (!link) return null;
  return /^https?:\/\//i.test(link) ? link : `https://${link}`;
};

/** 원문 링크 텍스트 — "계약명.pdf" 형태. 확장자 없으면 계약명만 */
export const formatContractFileLabel = (contract: ElawContract): string => {
  const name = formatContractText(contract.contractName);
  const ext = contract.fileExtension?.trim();
  return ext ? `${name.replace(/\.$/, '')}.${ext.replace(/^\./, '')}` : name;
};
